import { Autocomplete, Box, createFilterOptions, TextField } from "@mui/material";
import { useEffect, useRef, useState } from "react";

const BrandNameAuto = ({ selected, setProd, getdataforbar, inputVal, options }) => {


    return <div style={{ marginLeft: "3px" }
    }>
        <Autocomplete
            options={options}
            value={selected}
            onInputChange={getdataforbar}
            onChange={(e, value) => {
                console.log(value.brand_name);
                setProd(value);
            }}
            // filterOptions={filterOptions}
            getOptionLabel={option => option.brand_name}
            // getOptionLabel={option => option.prod_code}
            renderOption={(props, option) => (<Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>

                {option.id} {option.brand_name}
            </Box>)
            }
            renderInput={(params) => (
                <TextField
                    // {...input}
                    {...params} label="Брэнд нэр" variant="outlined" />
            )} />
    </div >
}

export default BrandNameAuto